var items = {
  "block.minecraft.air": "aer",
  "block.minecraft.stone": "saxum",
  "block.minecraft.granite": "granitum",
  "block.minecraft.polished_granite": "granitum politum",
  "block.minecraft.diorite": "diorites",
  "block.minecraft.polished_diorite": "diorites politus",
  "block.minecraft.andesite": "andesites",
  "block.minecraft.polished_andesite": "andesites politus",
  "block.minecraft.grass_block": "cubus graminis",
  "block.minecraft.dirt": "humus",
  "block.minecraft.coarse_dirt": "humus asper",
  "block.minecraft.podzol": "subcinerarium",
  "block.minecraft.crimson_nylium": "infelium coccinum",
  "block.minecraft.warped_nylium": "infelium distortum",
  "block.minecraft.cobblestone": "lapilli",
  "block.minecraft.oak_planks": "tabulae querceae",
  "block.minecraft.spruce_planks": "tabulae piceae",
  "block.minecraft.birch_planks": "tabulae betullae",
  "block.minecraft.jungle_planks": "tabulae theobromatis",
  "block.minecraft.acacia_planks": "tabulae acaciae",
  "block.minecraft.dark_oak_planks": "tabulae quercus nigrae",
  "block.minecraft.crimson_planks": "tabulae coccinae",
  "block.minecraft.warped_planks": "tabulae distortae",
  "block.minecraft.oak_sapling": "arbuscula quercus",
  "block.minecraft.spruce_sapling": "arbuscula piceae",
  "block.minecraft.birch_sapling": "arbuscula betullae",
  "block.minecraft.jungle_sapling": "arbuscula theobromatis",
  "block.minecraft.acacia_sapling": "arbuscula acaciae",
  "block.minecraft.dark_oak_sapling": "arbuscula quercus nigrae",
  "block.minecraft.bedrock": "saxum infimum",
  "block.minecraft.sand": "harena",
  "block.minecraft.red_sand": "harena rubra",
  "block.minecraft.gravel": "glarea",
  "block.minecraft.gold_ore": "aes aureum",
  "block.minecraft.iron_ore": "aes ferreum",
  "block.minecraft.coal_ore": "aes carbonarium",
  "block.minecraft.nether_gold_ore": "aes aureum infernum",
  "block.minecraft.oak_log": "truncus quercus",
  "block.minecraft.spruce_log": "truncus piceae",
  "block.minecraft.birch_log": "truncus betullae",
  "block.minecraft.jungle_log": "truncus theobromatis",
  "block.minecraft.acacia_log": "truncus acaciae",
  "block.minecraft.dark_oak_log": "truncus quercus nigrae",
  "block.minecraft.crimson_stem": "caulis coccinus",
  "block.minecraft.warped_stem": "caulis distortus",
  "block.minecraft.stripped_oak_log": "truncus quercus decorticatus",
  "block.minecraft.stripped_spruce_log": "truncus piceae decorticatus",
  "block.minecraft.stripped_birch_log": "truncus betullae decorticatus",
  "block.minecraft.stripped_jungle_log": "truncus theobromatis decorticatus",
  "block.minecraft.stripped_acacia_log": "truncus acaciae decorticatus",
  "block.minecraft.stripped_dark_oak_log": "truncus quercus nigrae decorticatus",
  "block.minecraft.stripped_crimson_stem": "caulis coccinus decorticatus",
  "block.minecraft.stripped_warped_stem": "caulis distortus decorticatus",
  "block.minecraft.stripped_oak_wood": "lignum querceum decorticatum",
  "block.minecraft.stripped_spruce_wood": "lignum piceae decorticatum",
  "block.minecraft.stripped_birch_wood": "lignum betullae decorticatum",
  "block.minecraft.stripped_jungle_wood": "lignum theobromatis decorticatus",
  "block.minecraft.stripped_acacia_wood": "lignum acaciae decorticatum",
  "block.minecraft.stripped_dark_oak_wood": "lignum quercus nigrae decorticatum",
  "block.minecraft.stripped_crimson_hyphae": "hyphae coccinae decorticatae",
  "block.minecraft.stripped_warped_hyphae": "hyphae distortae decorticatae",
  "block.minecraft.oak_wood": "lignum querceum",
  "block.minecraft.spruce_wood": "lignum piceae",
  "block.minecraft.birch_wood": "lignum betullae",
  "block.minecraft.jungle_wood": "lignum theobromatis",
  "block.minecraft.acacia_wood": "lignum acaciae",
  "block.minecraft.dark_oak_wood": "lignum quercus nigrae",
  "block.minecraft.crimson_hyphae": "hyphae coccinae",
  "block.minecraft.warped_hyphae": "hyphae distortae",
  "block.minecraft.oak_leaves": "foliae quercus",
  "block.minecraft.spruce_leaves": "foliae piceae",
  "block.minecraft.birch_leaves": "foliae betullae",
  "block.minecraft.jungle_leaves": "folia theobromae",
  "block.minecraft.acacia_leaves": "foliae acaciae",
  "block.minecraft.dark_oak_leaves": "foliae quercus nigrae",
  "block.minecraft.sponge": "spongia",
  "block.minecraft.wet_sponge": "spongia madida",
  "block.minecraft.glass": "vitrum",
  "block.minecraft.lapis_ore": "aes lapidis lazuli",
  "block.minecraft.lapis_block": "cubus lapidis lazuli",
  "block.minecraft.dispenser": "distributor",
  "block.minecraft.sandstone": "lapis harenarius",
  "block.minecraft.chiseled_sandstone": "lapis harenarius caelatus",
  "block.minecraft.cut_sandstone": "lapis harenarius scalptus",
  "block.minecraft.note_block": "cubus musicus",
  "block.minecraft.powered_rail": "ferrivia electrica",
  "block.minecraft.detector_rail": "ferrivia percipens",
  "block.minecraft.sticky_piston": "embolus tenax",
  "block.minecraft.cobweb": "araneum",
  "block.minecraft.grass": "gramen",
  "block.minecraft.fern": "filix",
  "block.minecraft.dead_bush": "frutex mortuus",
  "block.minecraft.seagrass": "gramen marinum",
  "block.minecraft.sea_pickle": "pyrosoma",
  "block.minecraft.piston": "embolus",
  "block.minecraft.white_wool": "lana alba",
  "block.minecraft.orange_wool": "lana aurantia",
  "block.minecraft.magenta_wool": "lana rubropurpurea",
  "block.minecraft.light_blue_wool": "lana aeria",
  "block.minecraft.yellow_wool": "lana flava",
  "block.minecraft.lime_wool": "lana prasina",
  "block.minecraft.pink_wool": "lana rosea",
  "block.minecraft.gray_wool": "lana cinerea",
  "block.minecraft.light_gray_wool": "lana cana",
  "block.minecraft.cyan_wool": "lana cyanea",
  "block.minecraft.purple_wool": "lana purpurea",
  "block.minecraft.blue_wool": "lana caerulea",
  "block.minecraft.brown_wool": "lana brunnea",
  "block.minecraft.green_wool": "lana viridis",
  "block.minecraft.red_wool": "lana rubra",
  "block.minecraft.black_wool": "lana nigra",
  "block.minecraft.dandelion": "taraxacum",
  "block.minecraft.poppy": "papaver",
  "block.minecraft.blue_orchid": "vanda coerulea",
  "block.minecraft.allium": "allium",
  "block.minecraft.azure_bluet": "houstonia caerulea",
  "block.minecraft.red_tulip": "tulipa rubra",
  "block.minecraft.orange_tulip": "tulipa aurantia",
  "block.minecraft.white_tulip": "tulipa alba",
  "block.minecraft.pink_tulip": "tulipa rosea",
  "block.minecraft.oxeye_daisy": "leucanthemum vulgare",
  "block.minecraft.cornflower": "cyanus",
  "block.minecraft.lily_of_the_valley": "convallaria",
  "block.minecraft.wither_rose": "rosa deurens",
  "block.minecraft.brown_mushroom": "fungus brunneus",
  "block.minecraft.red_mushroom": "fungus ruber",
  "block.minecraft.crimson_fungus": "fungus coccinus",
  "block.minecraft.warped_fungus": "fungus distortus",
  "block.minecraft.crimson_roots": "radices coccinae",
  "block.minecraft.warped_roots": "radices distortae",
  "block.minecraft.nether_sprouts": "pampini inferni",
  "block.minecraft.weeping_vines": "vineae lacrimosae",
  "block.minecraft.twisting_vines": "vineae contortae",
  "block.minecraft.sugar_cane": "canna sacchari",
  "block.minecraft.kelp": "alga",
  "block.minecraft.bamboo": "bambusa",
  "block.minecraft.gold_block": "cubus aureus",
  "block.minecraft.iron_block": "cubus ferreus",
  "block.minecraft.oak_slab": "gradus querceus",
  "block.minecraft.spruce_slab": "gradus piceae",
  "block.minecraft.birch_slab": "gradus betullae",
  "block.minecraft.jungle_slab": "gradus theobromatis",
  "block.minecraft.acacia_slab": "gradus acaciae",
  "block.minecraft.dark_oak_slab": "gradus quercus nigrae",
  "block.minecraft.crimson_slab": "gradus coccinus",
  "block.minecraft.warped_slab": "gradus distortus",
  "block.minecraft.stone_slab": "gradus saxeus",
  "block.minecraft.smooth_stone_slab": "gradus saxi glabri",
  "block.minecraft.sandstone_slab": "gradus lapidis harenarii",
  "block.minecraft.cut_sandstone_slab": "gradus lapidis harenarii scalpti",
  "block.minecraft.petrified_oak_slab": "gradus querceus saxeus",
  "block.minecraft.cobblestone_slab": "gradus lapillorum",
  "block.minecraft.brick_slab": "gradus latericius",
  "block.minecraft.stone_brick_slab": "gradus laterum saxeorum",
  "block.minecraft.nether_brick_slab": "gradus laterum infernorum",
  "block.minecraft.quartz_slab": "gradus crystallinus",
  "block.minecraft.red_sandstone_slab": "gradus lapidis harenarii rubri",
  "block.minecraft.cut_red_sandstone_slab": "gradus lapidis rubri harenarii scalpti",
  "block.minecraft.purpur_slab": "gradus purpureus",
  "block.minecraft.prismarine_slab": "gradus prismarinus",
  "block.minecraft.prismarine_brick_slab": "gradus laterum prismarinorum",
  "block.minecraft.dark_prismarine_slab": "gradus prismarinus obscurus",
  "block.minecraft.smooth_quartz": "cubus crystalli glabri",
  "block.minecraft.smooth_red_sandstone": "lapis harenarius ruber glaber",
  "block.minecraft.smooth_sandstone": "lapis harenarius glaber",
  "block.minecraft.smooth_stone": "saxum glabrum",
  "block.minecraft.bricks": "lateres",
  "block.minecraft.tnt": "dynamites",
  "block.minecraft.bookshelf": "armarium",
  "block.minecraft.mossy_cobblestone": "lapilli muscosi",
  "block.minecraft.obsidian": "lapis obsidianus",
  "block.minecraft.torch": "fax",
  "block.minecraft.end_rod": "virga finalis",
  "block.minecraft.chorus_plant": "caulis chori",
  "block.minecraft.chorus_flower": "flos chori",
  "block.minecraft.purpur_block": "cubus purpureus",
  "block.minecraft.purpur_pillar": "columna purpurea",
  "block.minecraft.purpur_stairs": "scalae purpureae",
  "block.minecraft.spawner": "genitor",
  "block.minecraft.oak_stairs": "scalae querceae",
  "block.minecraft.chest": "cista",
  "block.minecraft.diamond_ore": "aes adamantinum",
  "block.minecraft.diamond_block": "cubus adamantinus",
  "block.minecraft.crafting_table": "mensa fabricationis",
  "block.minecraft.farmland": "terra arata",
  "block.minecraft.furnace": "fornax",
  "block.minecraft.ladder": "scala",
  "block.minecraft.rail": "ferrivia",
  "block.minecraft.cobblestone_stairs": "scalae lapideae",
  "block.minecraft.lever": "vectis",
  "block.minecraft.stone_pressure_plate": "tabula premenda saxea",
  "block.minecraft.oak_pressure_plate": "tabula premenda quercea",
  "block.minecraft.spruce_pressure_plate": "tabula premenda piceae",
  "block.minecraft.birch_pressure_plate": "tabula premenda betullae",
  "block.minecraft.jungle_pressure_plate": "tabula premenda theobromatis",
  "block.minecraft.acacia_pressure_plate": "tabula premenda acaciae",
  "block.minecraft.dark_oak_pressure_plate": "tabula premenda quercus nigrae",
  "block.minecraft.crimson_pressure_plate": "tabula premenda coccina",
  "block.minecraft.warped_pressure_plate": "tabula premenda distorta",
  "block.minecraft.polished_blackstone_pressure_plate": "tabula premenda saxi nigri politi",
  "block.minecraft.redstone_ore": "aes rubrolapideum",
  "block.minecraft.redstone_torch": "fax rubrolapidea",
  "block.minecraft.snow": "nix",
  "block.minecraft.ice": "glacies",
  "block.minecraft.snow_block": "cubus niveus",
  "block.minecraft.cactus": "cactus",
  "block.minecraft.clay": "argilla",
  "block.minecraft.jukebox": "phonographum",
  "block.minecraft.oak_fence": "saepes quercea",
  "block.minecraft.spruce_fence": "saepes piceae",
  "block.minecraft.birch_fence": "saepes betullae",
  "block.minecraft.jungle_fence": "saepes theobromatis",
  "block.minecraft.acacia_fence": "saepes acaciae",
  "block.minecraft.dark_oak_fence": "saepes quercus nigrae",
  "block.minecraft.crimson_fence": "saepes coccina",
  "block.minecraft.warped_fence": "saepes distorta",
  "block.minecraft.pumpkin": "cucurbita",
  "block.minecraft.carved_pumpkin": "curcurbita sculpta",
  "block.minecraft.netherrack": "infernisaxum",
  "block.minecraft.soul_sand": "harena animarum",
  "block.minecraft.soul_soil": "humus animarum",
  "block.minecraft.basalt": "basaltes",
  "block.minecraft.polished_basalt": "basaltes politus",
  "block.minecraft.soul_torch": "fax animarum",
  "block.minecraft.glowstone": "lucilapis",
  "block.minecraft.jack_o_lantern": "ignis fatuus",
  "block.minecraft.oak_trapdoor": "ostium horizontale querceum",
  "block.minecraft.spruce_trapdoor": "ostium horizontale piceae",
  "block.minecraft.birch_trapdoor": "ostium horizontale betulae",
  "block.minecraft.jungle_trapdoor": "ostium horizontale theobromatis",
  "block.minecraft.acacia_trapdoor": "ostium horizontale acaciae",
  "block.minecraft.dark_oak_trapdoor": "ostium horizontale quercus nigrae",
  "block.minecraft.crimson_trapdoor": "ostium horizontale coccinum",
  "block.minecraft.warped_trapdoor": "ostium horizontale distortum",
  "block.minecraft.infested_stone": "saxum infestatum",
  "block.minecraft.infested_cobblestone": "lapilli infestati",
  "block.minecraft.infested_stone_bricks": "lateres saxei infestati",
  "block.minecraft.infested_mossy_stone_bricks": "lateres saxei muscosi infestati",
  "block.minecraft.infested_cracked_stone_bricks": "lateres saxei rimosi infestati",
  "block.minecraft.infested_chiseled_stone_bricks": "lateres saxei caelati infestati",
  "block.minecraft.stone_bricks": "lateres saxei",
  "block.minecraft.mossy_stone_bricks": "lateres saxei muscosi",
  "block.minecraft.cracked_stone_bricks": "lateres saxei rimosi",
  "block.minecraft.chiseled_stone_bricks": "lateres saxei caelati",
  "block.minecraft.brown_mushroom_block": "cubus fungi bruni",
  "block.minecraft.red_mushroom_block": "cubus fungi rubri",
  "block.minecraft.mushroom_stem": "caulis funginus",
  "block.minecraft.iron_bars": "vectes ferrei",
  "block.minecraft.chain": "concatenatus",
  "block.minecraft.glass_pane": "fenestra vitrea",
  "block.minecraft.melon": "pepo",
  "block.minecraft.vine": "vineae",
  "block.minecraft.oak_fence_gate": "foris quercea",
  "block.minecraft.spruce_fence_gate": "foris piceae",
  "block.minecraft.birch_fence_gate": "foris betullae",
  "block.minecraft.jungle_fence_gate": "foris theobromatis",
  "block.minecraft.acacia_fence_gate": "foris acaciae",
  "block.minecraft.dark_oak_fence_gate": "foris quercus nigrae",
  "block.minecraft.crimson_fence_gate": "foris coccina",
  "block.minecraft.warped_fence_gate": "foris distorta",
  "block.minecraft.brick_stairs": "scalae latericiae",
  "block.minecraft.stone_brick_stairs": "scalae laterum saxeorum",
  "block.minecraft.mycelium": "mycelium",
  "block.minecraft.lily_pad": "nymphaea",
  "block.minecraft.nether_bricks": "lateres inferni",
  "block.minecraft.cracked_nether_bricks": "lateres inferni rimosi",
  "block.minecraft.chiseled_nether_bricks": "lateres inferni caelati",
  "block.minecraft.nether_brick_fence": "saepes laterum infernorum",
  "block.minecraft.nether_brick_stairs": "scalae laterum infernorum",
  "block.minecraft.enchanting_table": "mensa incantandi",
  "block.minecraft.end_portal_frame": "replum portae finalis",
  "block.minecraft.end_stone": "saxum finale",
  "block.minecraft.end_stone_bricks": "lateres saxi finalis",
  "block.minecraft.dragon_egg": "ovum draconis",
  "block.minecraft.redstone_lamp": "lampas rubrolapidea",
  "block.minecraft.sandstone_stairs": "scalae lapidis harenarii",
  "block.minecraft.emerald_ore": "aes smaragdinum",
  "block.minecraft.ender_chest": "cista finalis",
  "block.minecraft.tripwire_hook": "hamus laquei",
  "block.minecraft.emerald_block": "cubus smaragdinus",
  "block.minecraft.spruce_stairs": "scalae piceae",
  "block.minecraft.birch_stairs": "scalae betullae",
  "block.minecraft.jungle_stairs": "scalae theobromatis",
  "block.minecraft.crimson_stairs": "scalae coccinae",
  "block.minecraft.warped_stairs": "scalae distortae",
  "block.minecraft.command_block": "cubus iussorum",
  "block.minecraft.beacon": "radiator",
  "block.minecraft.cobblestone_wall": "murus lapideus",
  "block.minecraft.mossy_cobblestone_wall": "murus lapideus muscosus",
  "block.minecraft.brick_wall": "murus latericius",
  "block.minecraft.prismarine_wall": "murus prismarinus",
  "block.minecraft.red_sandstone_wall": "murus lapidis harenarii rubri",
  "block.minecraft.mossy_stone_brick_wall": "murus laterum saxeorum muscosorum",
  "block.minecraft.granite_wall": "murus graniteus",
  "block.minecraft.stone_brick_wall": "murus laterum saxeorum",
  "block.minecraft.nether_brick_wall": "murus laterum infernorum",
  "block.minecraft.andesite_wall": "murus andesitae",
  "block.minecraft.red_nether_brick_wall": "murus laterum infernorum rubrorum",
  "block.minecraft.sandstone_wall": "murus lapidis harenarii",
  "block.minecraft.end_stone_brick_wall": "murus laterum saxi finalis",
  "block.minecraft.diorite_wall": "murus dioritae",
  "block.minecraft.blackstone_wall": "murus saxi nigri",
  "block.minecraft.polished_blackstone_wall": "murus saxi nigri politi",
  "block.minecraft.polished_blackstone_brick_wall": "murus laterum saxi nigri politi",
  "block.minecraft.stone_button": "premendus saxeus",
  "block.minecraft.oak_button": "premendus querceus",
  "block.minecraft.spruce_button": "premendus piceae",
  "block.minecraft.birch_button": "premendus betullae",
  "block.minecraft.jungle_button": "globulus theobromeus",
  "block.minecraft.acacia_button": "premendus acaciae",
  "block.minecraft.dark_oak_button": "premendus quercus nigrae",
  "block.minecraft.crimson_button": "premendus coccinus",
  "block.minecraft.warped_button": "premendus distortus",
  "block.minecraft.polished_blackstone_button": "premendus saxi nigri politi",
  "block.minecraft.anvil": "incus",
  "block.minecraft.chipped_anvil": "incus dedolatus",
  "block.minecraft.damaged_anvil": "incus fractus",
  "block.minecraft.trapped_chest": "cista dolosa",
  "block.minecraft.light_weighted_pressure_plate": "tabula permenda molibus parvis",
  "block.minecraft.heavy_weighted_pressure_plate": "tabula premenda molibus magnis",
  "block.minecraft.daylight_detector": "senstrum lucis diei",
  "block.minecraft.redstone_block": "cubus rubrolapideus",
  "block.minecraft.nether_quartz_ore": "aes crystalli inferni",
  "block.minecraft.hopper": "infundibulum",
  "block.minecraft.chiseled_quartz_block": "cubus crystallinus caelatus",
  "block.minecraft.quartz_block": "cubus crystallinum",
  "block.minecraft.quartz_bricks": "lateres crystallini",
  "block.minecraft.quartz_pillar": "columna crystallina",
  "block.minecraft.quartz_stairs": "scalae crystallinae",
  "block.minecraft.activator_rail": "ferrivia incitans",
  "block.minecraft.dropper": "demittetrum",
  "block.minecraft.white_terracotta": "terra cocta alba",
  "block.minecraft.orange_terracotta": "terra cocta aurantia",
  "block.minecraft.magenta_terracotta": "terra cocta rubropurpurea",
  "block.minecraft.light_blue_terracotta": "terra cocta aeria",
  "block.minecraft.yellow_terracotta": "terra cocta flava",
  "block.minecraft.lime_terracotta": "terra cocta prasina",
  "block.minecraft.pink_terracotta": "terra cocta rosea",
  "block.minecraft.gray_terracotta": "terra cocta cinerea",
  "block.minecraft.light_gray_terracotta": "terra cocta cana",
  "block.minecraft.cyan_terracotta": "terra cocta cyanea",
  "block.minecraft.purple_terracotta": "terra cocta purpurea",
  "block.minecraft.blue_terracotta": "terra cocta caerulea",
  "block.minecraft.brown_terracotta": "terra cocta brunnea",
  "block.minecraft.green_terracotta": "terra cocta viridis",
  "block.minecraft.red_terracotta": "terra cocta rubra",
  "block.minecraft.black_terracotta": "terra cocta nigra",
  "block.minecraft.barrier": "claustrum",
  "block.minecraft.iron_trapdoor": "ostium horizontale ferreum",
  "block.minecraft.hay_block": "fascis faeni",
  "block.minecraft.white_carpet": "tapes albus",
  "block.minecraft.orange_carpet": "tapes aurantius",
  "block.minecraft.magenta_carpet": "tapes rubropurpurea",
  "block.minecraft.light_blue_carpet": "tapes aerius",
  "block.minecraft.yellow_carpet": "tapes flavus",
  "block.minecraft.lime_carpet": "tapes prasinus",
  "block.minecraft.pink_carpet": "tapes roseus",
  "block.minecraft.gray_carpet": "tapes cinereus",
  "block.minecraft.light_gray_carpet": "tapes canus",
  "block.minecraft.cyan_carpet": "tapes cyaneus",
  "block.minecraft.purple_carpet": "tapes purpureus",
  "block.minecraft.blue_carpet": "tapes caeruleus",
  "block.minecraft.brown_carpet": "tapes brunneus",
  "block.minecraft.green_carpet": "tapes viridis",
  "block.minecraft.red_carpet": "tapes ruber",
  "block.minecraft.black_carpet": "tapes niger",
  "block.minecraft.terracotta": "terra cocta",
  "block.minecraft.coal_block": "cubus carbonarius",
  "block.minecraft.packed_ice": "glacies stipata",
  "block.minecraft.acacia_stairs": "scalae acaciae",
  "block.minecraft.dark_oak_stairs": "scalae quercus nigrae",
  "block.minecraft.slime_block": "cubus muci",
  "block.minecraft.grass_path": "semita graminosa",
  "block.minecraft.sunflower": "helianthus",
  "block.minecraft.lilac": "syringa",
  "block.minecraft.rose_bush": "frutex rosarum",
  "block.minecraft.peony": "paeonia",
  "block.minecraft.tall_grass": "gramen altum",
  "block.minecraft.large_fern": "filix magna",
  "block.minecraft.white_stained_glass": "vitrum tinctum album",
  "block.minecraft.orange_stained_glass": "vitrum tinctum aurantium",
  "block.minecraft.magenta_stained_glass": "vitrum tinctum rubropurpureum",
  "block.minecraft.light_blue_stained_glass": "vitrum tinctum aerium",
  "block.minecraft.yellow_stained_glass": "vitrum tinctum flavum",
  "block.minecraft.lime_stained_glass": "vitrum tinctum prasinum",
  "block.minecraft.pink_stained_glass": "vitrum tinctum roseum",
  "block.minecraft.gray_stained_glass": "vitrum tinctum cinereum",
  "block.minecraft.light_gray_stained_glass": "vitrum tinctum canum",
  "block.minecraft.cyan_stained_glass": "vitrum tinctum cyaneum",
  "block.minecraft.purple_stained_glass": "vitrum tinctum purpureum",
  "block.minecraft.blue_stained_glass": "vitrum tinctum caeruleum",
  "block.minecraft.brown_stained_glass": "vitrum tinctum brunneum",
  "block.minecraft.green_stained_glass": "vitrum tinctum viride",
  "block.minecraft.red_stained_glass": "vitrum tinctum rubrum",
  "block.minecraft.black_stained_glass": "vitrum tinctum nigrum",
  "block.minecraft.white_stained_glass_pane": "fenestra vitrea tincta alba",
  "block.minecraft.orange_stained_glass_pane": "fenestra vitrea tincta aurantia",
  "block.minecraft.magenta_stained_glass_pane": "fenestra vitrea tincta rubropurpurea",
  "block.minecraft.light_blue_stained_glass_pane": "fenestra vitrea tincta aeria",
  "block.minecraft.yellow_stained_glass_pane": "fenestra vitrea tincta flava",
  "block.minecraft.lime_stained_glass_pane": "fenestra vitrea tincta prasina",
  "block.minecraft.pink_stained_glass_pane": "fenestra vitrea tincta rosa",
  "block.minecraft.gray_stained_glass_pane": "fenestra vitrea tincta cinerea",
  "block.minecraft.light_gray_stained_glass_pane": "fenestra vitrea tincta cana",
  "block.minecraft.cyan_stained_glass_pane": "fenestra vitrea tincta cyanea",
  "block.minecraft.purple_stained_glass_pane": "fenestra vitrea tincta purpurea",
  "block.minecraft.blue_stained_glass_pane": "fenestra vitrea tincta caerulea",
  "block.minecraft.brown_stained_glass_pane": "fenestra vitrea tincta brunea",
  "block.minecraft.green_stained_glass_pane": "fenestra vitrea tincta viridis",
  "block.minecraft.red_stained_glass_pane": "fenestra vitrea tincta rubra",
  "block.minecraft.black_stained_glass_pane": "fenestra vitrea tincta nigra",
  "block.minecraft.prismarine": "prismarina",
  "block.minecraft.prismarine_bricks": "lateres prismarini",
  "block.minecraft.dark_prismarine": "prismarina obscura",
  "block.minecraft.prismarine_stairs": "scalae prismarinae",
  "block.minecraft.prismarine_brick_stairs": "gradus laterum prismarinorum",
  "block.minecraft.dark_prismarine_stairs": "scalae prismarinae obscurae",
  "block.minecraft.sea_lantern": "lanterna marina",
  "block.minecraft.red_sandstone": "lapis harenarius ruber",
  "block.minecraft.chiseled_red_sandstone": "lapis harenarius ruber caelatus",
  "block.minecraft.cut_red_sandstone": "lapis harenarius ruber scalptus",
  "block.minecraft.red_sandstone_stairs": "scalae lapidis harenarii rubri",
  "block.minecraft.repeating_command_block": "cubus iussorum iterans",
  "block.minecraft.chain_command_block": "cubus iussorum concatenatus",
  "block.minecraft.magma_block": "cubus magmatis",
  "block.minecraft.nether_wart_block": "cubus verrucarum infernarum",
  "block.minecraft.warped_wart_block": "cubus verrucarum distortarum",
  "block.minecraft.red_nether_bricks": "lateres inferni rubri",
  "block.minecraft.bone_block": "cubus osseus",
  "block.minecraft.structure_void": "concavum structurae",
  "block.minecraft.observer": "spectator",
  "block.minecraft.shulker_box": "capsa concheri",
  "block.minecraft.white_shulker_box": "alba capsa concheri",
  "block.minecraft.orange_shulker_box": "aurantia capsa concheri",
  "block.minecraft.magenta_shulker_box": "rubropurpurea capsa concheri",
  "block.minecraft.light_blue_shulker_box": "aeria capsa concheri",
  "block.minecraft.yellow_shulker_box": "flava capsa concheri",
  "block.minecraft.lime_shulker_box": "prasina capsa concheri",
  "block.minecraft.pink_shulker_box": "rosea capsa concheri",
  "block.minecraft.gray_shulker_box": "cinerea capsa concheri",
  "block.minecraft.light_gray_shulker_box": "cana capsa concheri",
  "block.minecraft.cyan_shulker_box": "cyanea capsa concheri",
  "block.minecraft.purple_shulker_box": "purpurea capsa concheri",
  "block.minecraft.blue_shulker_box": "cerulea capsa concheri",
  "block.minecraft.brown_shulker_box": "brunnea capsa concheri",
  "block.minecraft.green_shulker_box": "viridis capsa concheri",
  "block.minecraft.red_shulker_box": "rubra capsa concheri",
  "block.minecraft.black_shulker_box": "nigra capsa concheri",
  "block.minecraft.white_glazed_terracotta": "terra cocta smaltata alba",
  "block.minecraft.orange_glazed_terracotta": "terra cocta smaltata aurantia",
  "block.minecraft.magenta_glazed_terracotta": "terra cocta smaltata rubropurpurea",
  "block.minecraft.light_blue_glazed_terracotta": "terra cocta smaltata aeria",
  "block.minecraft.yellow_glazed_terracotta": "terra cocta smaltata flava",
  "block.minecraft.lime_glazed_terracotta": "terra cocta smaltata prasina",
  "block.minecraft.pink_glazed_terracotta": "terra cocta smaltata rosea",
  "block.minecraft.gray_glazed_terracotta": "terra cocta smaltata cinerea",
  "block.minecraft.light_gray_glazed_terracotta": "terra cocta smaltata cana",
  "block.minecraft.cyan_glazed_terracotta": "terra cocta smaltata cyanea",
  "block.minecraft.purple_glazed_terracotta": "terra cocta smaltata purpurea",
  "block.minecraft.blue_glazed_terracotta": "terra cocta smaltata caerulea",
  "block.minecraft.brown_glazed_terracotta": "terra cocta smaltata brunnea",
  "block.minecraft.green_glazed_terracotta": "terra cocta smaltata viridis",
  "block.minecraft.red_glazed_terracotta": "terra cocta smaltata rubra",
  "block.minecraft.black_glazed_terracotta": "terra cocta smaltata nigra",
  "block.minecraft.white_concrete": "opus caementicium album",
  "block.minecraft.orange_concrete": "opus caementicium aurantium",
  "block.minecraft.magenta_concrete": "opus caementicium rubropurpureum",
  "block.minecraft.light_blue_concrete": "opus caementicium aerium",
  "block.minecraft.yellow_concrete": "opus caementicium flavum",
  "block.minecraft.lime_concrete": "opus caementicium prasinum",
  "block.minecraft.pink_concrete": "opus caementicium roseum",
  "block.minecraft.gray_concrete": "opus caementicium cinereum",
  "block.minecraft.light_gray_concrete": "opus caementicium canum",
  "block.minecraft.cyan_concrete": "opus caementicium cyaneum",
  "block.minecraft.purple_concrete": "opus caementicium purpureum",
  "block.minecraft.blue_concrete": "opus caementicium caeruleum",
  "block.minecraft.brown_concrete": "opus caementicium brunneum",
  "block.minecraft.green_concrete": "opus caementicium viride",
  "block.minecraft.red_concrete": "opus caementicium rubrum",
  "block.minecraft.black_concrete": "opus caementicium nigrum",
  "block.minecraft.white_concrete_powder": "caementum album",
  "block.minecraft.orange_concrete_powder": "caementum aurantium",
  "block.minecraft.magenta_concrete_powder": "caementum rubropurpureum",
  "block.minecraft.light_blue_concrete_powder": "caementum aerium",
  "block.minecraft.yellow_concrete_powder": "caementum flavum",
  "block.minecraft.lime_concrete_powder": "caementum prasinum",
  "block.minecraft.pink_concrete_powder": "caementum roseum",
  "block.minecraft.gray_concrete_powder": "caementum cinereum",
  "block.minecraft.light_gray_concrete_powder": "caementum canum",
  "block.minecraft.cyan_concrete_powder": "caementum cyaneum",
  "block.minecraft.purple_concrete_powder": "caementum purpureum",
  "block.minecraft.blue_concrete_powder": "caementum caeruleum",
  "block.minecraft.brown_concrete_powder": "caementum brunneum",
  "block.minecraft.green_concrete_powder": "caementum viride",
  "block.minecraft.red_concrete_powder": "caementum rubrum",
  "block.minecraft.black_concrete_powder": "caementum nigrum",
  "block.minecraft.turtle_egg": "ovum testudinis",
  "block.minecraft.dead_tube_coral_block": "cubus corallii tubulati mortui",
  "block.minecraft.dead_brain_coral_block": "cubus corallii ramosi mortui",
  "block.minecraft.dead_bubble_coral_block": "cubus corallii bullati mortui",
  "block.minecraft.dead_fire_coral_block": "cubus corallii ignicolori mortui",
  "block.minecraft.dead_horn_coral_block": "cubus corallii cornuti mortui",
  "block.minecraft.tube_coral_block": "cubus corallii tubulati",
  "block.minecraft.brain_coral_block": "cubus corallii ramosii",
  "block.minecraft.bubble_coral_block": "cubus corallii bullati",
  "block.minecraft.fire_coral_block": "cubus corallii ignicolori",
  "block.minecraft.horn_coral_block": "cubus corallii cornuti",
  "block.minecraft.tube_coral": "corallium tubulatum",
  "block.minecraft.brain_coral": "corallium ramosum",
  "block.minecraft.bubble_coral": "corallium bullatum",
  "block.minecraft.fire_coral": "corallium ignicolorum",
  "block.minecraft.horn_coral": "corallium cornutum",
  "block.minecraft.dead_brain_coral": "corallium ramosum mortuum",
  "block.minecraft.dead_bubble_coral": "corallium bullatum mortuum",
  "block.minecraft.dead_fire_coral": "corallium ignicolorum mortuum",
  "block.minecraft.dead_horn_coral": "corallium cornutum mortuum",
  "block.minecraft.dead_tube_coral": "corallium tubulatum mortuum",
  "block.minecraft.tube_coral_fan": "gorgonia tubulata",
  "block.minecraft.brain_coral_fan": "gorgonia ramosa",
  "block.minecraft.bubble_coral_fan": "gorgonia bullata",
  "block.minecraft.fire_coral_fan": "gorgonia ignicolora",
  "block.minecraft.horn_coral_fan": "gorgonia cornuta",
  "block.minecraft.dead_tube_coral_fan": "gorgonia tubulata mortua",
  "block.minecraft.dead_brain_coral_fan": "gorgonia ramosa mortua",
  "block.minecraft.dead_bubble_coral_fan": "gorgonia bullata mortua",
  "block.minecraft.dead_fire_coral_fan": "gorgonia ignicolora mortua",
  "block.minecraft.dead_horn_coral_fan": "gorgonia cornuta mortua",
  "block.minecraft.blue_ice": "glacies caerulea",
  "block.minecraft.conduit": "canalis",
  "block.minecraft.polished_granite_stairs": "scalae graniteae politae",
  "block.minecraft.smooth_red_sandstone_stairs": "gradus lapidis harenarii rubri glabri",
  "block.minecraft.mossy_stone_brick_stairs": "scalae laterum saxeorum muscosorum",
  "block.minecraft.polished_diorite_stairs": "gradus dioritorum politorum",
  "block.minecraft.mossy_cobblestone_stairs": "scalae lapillorum muscosorum",
  "block.minecraft.end_stone_brick_stairs": "scalae laterum saxi finalis",
  "block.minecraft.stone_stairs": "scalae saxeae",
  "block.minecraft.smooth_sandstone_stairs": "gradus lapidis harenarii glabri",
  "block.minecraft.smooth_quartz_stairs": "gradus crystalli glabri",
  "block.minecraft.granite_stairs": "scalae graniteae",
  "block.minecraft.andesite_stairs": "gradus andesitorum",
  "block.minecraft.red_nether_brick_stairs": "scalae laterum infernorum rubrorum",
  "block.minecraft.polished_andesite_stairs": "gradus andesitorum politorum",
  "block.minecraft.diorite_stairs": "scalae dioriteae",
  "block.minecraft.polished_granite_slab": "gradus graniteus politus",
  "block.minecraft.smooth_red_sandstone_slab": "gradus lapidis harenarii rubri glabri",
  "block.minecraft.mossy_stone_brick_slab": "gradus laterum saxeorum muscosorum",
  "block.minecraft.polished_diorite_slab": "gradus dioriti politi",
  "block.minecraft.mossy_cobblestone_slab": "gradus lapillorum muscosorum",
  "block.minecraft.end_stone_brick_slab": "gradus laterum saxi finalis",
  "block.minecraft.smooth_sandstone_slab": "gradus lapidis harenarii glabri",
  "block.minecraft.smooth_quartz_slab": "gradus crystalli glabri",
  "block.minecraft.granite_slab": "gradus graniteus",
  "block.minecraft.andesite_slab": "gradus andesitae",
  "block.minecraft.red_nether_brick_slab": "gradus laterum infernorum rubrorum",
  "block.minecraft.polished_andesite_slab": "gradus andesitae politi",
  "block.minecraft.diorite_slab": "gradus dioritae",
  "block.minecraft.scaffolding": "fulcimen",
  "block.minecraft.iron_door": "ianua ferrea",
  "block.minecraft.oak_door": "ostium querceum",
  "block.minecraft.spruce_door": "ostium piceae",
  "block.minecraft.birch_door": "ostium betulae",
  "block.minecraft.jungle_door": "ostium theobromatis",
  "block.minecraft.acacia_door": "ostium acaciae",
  "block.minecraft.dark_oak_door": "ostium quercus nigrae",
  "block.minecraft.crimson_door": "ostium coccinum",
  "block.minecraft.warped_door": "ostium distortum",
  "block.minecraft.repeater": "iteratrum rubrolapideum",
  "block.minecraft.comparator": "comparatrum rubrolapideum",
  "block.minecraft.structure_block": "cubus structurae",
  "block.minecraft.jigsaw": "cubus iunctionis",
  "item.minecraft.turtle_helmet": "testa testudinis□□in capite:□+2 armatura",
  "item.minecraft.scute": "scutulum",
  "item.minecraft.iron_shovel": "pala ferrea□□in manu priore:□+3.5 iniuria impetus□-3 velocitas inuriae",
  "item.minecraft.iron_pickaxe": "dolabra ferrea□□in manu priore:□+3 iniuria impetus□-2.8 velocitas inuriae",
  "item.minecraft.iron_axe": "securis ferrea□□in manu priore:□+8 iniuria impetus□-3.1 velocitas inuriae",
  "item.minecraft.flint_and_steel": "silex chalybsque",
  "item.minecraft.apple": "malum",
  "item.minecraft.bow": "arcus",
  "item.minecraft.arrow": "sagitta",
  "item.minecraft.coal": "carbo",
  "item.minecraft.charcoal": "carbo ex ligno",
  "item.minecraft.diamond": "adamas",
  "item.minecraft.iron_ingot": "later ferreus",
  "item.minecraft.gold_ingot": "later aurea",
  "item.minecraft.netherite_ingot": "later infernitae",
  "item.minecraft.netherite_scrap": "frustum infernitae",
  "item.minecraft.iron_sword": "gladius ferreus□□in manu priore:□+5 iniuria impetus□-2.4 velocitas inuriae",
  "item.minecraft.wooden_sword": "gladius ligneus□□in manu priore:□+3 iniuria impetus□-2.4 velocitas inuriae",
  "item.minecraft.wooden_shovel": "pala lignea□□in manu priore:□+1.5 iniuria impetus□-3 velocitas inuriae",
  "item.minecraft.wooden_pickaxe": "dolabra lignea□□in manu priore:□+1 iniuria impetus□-2.8 velocitas inuriae",
  "item.minecraft.wooden_axe": "securis lignea□□in manu priore:□+6 iniuria impetus□-3.2 velocitas inuriae",
  "item.minecraft.stone_sword": "gladius saxeus□□in manu priore:□+4 iniuria impetus□-2.4 velocitas inuriae",
  "item.minecraft.stone_shovel": "pala saxea□□in manu priore:□+2.5 iniuria impetus□-3 velocitas inuriae",
  "item.minecraft.stone_pickaxe": "dolabra saxea□□in manu priore:□+2 iniuria impetus□-2.8 velocitas inuriae",
  "item.minecraft.stone_axe": "securis saxeus□□in manu priore:□+8 iniuria impetus□-3.2 velocitas inuriae",
  "item.minecraft.diamond_sword": "gladius adamantinus□□in manu priore:□+6 iniuria impetus□-2.4 velocitas inuriae",
  "item.minecraft.diamond_shovel": "pala adamantina□□in manu priore:□+4.5 iniuria impetus□-3 velocitas inuriae",
  "item.minecraft.diamond_pickaxe": "dolabra adamantina□□in manu priore:□+4 iniuria impetus□-2.8 velocitas inuriae",
  "item.minecraft.diamond_axe": "securis adamantina□□in manu priore:□+8 iniuria impetus□-3 velocitas inuriae",
  "item.minecraft.stick": "virga",
  "item.minecraft.bowl": "patera",
  "item.minecraft.mushroom_stew": "ius funginum",
  "item.minecraft.golden_sword": "gladius aureus□□in manu priore:□+3 iniuria impetus□-2.4 velocitas inuriae",
  "item.minecraft.golden_shovel": "pala aurea□□in manu priore:□+1.5 iniuria impetus□-3 velocitas inuriae",
  "item.minecraft.golden_pickaxe": "dolabra aurea□□in manu priore:□+1 iniuria impetus□-2.8 velocitas inuriae",
  "item.minecraft.golden_axe": "securis aurea□□in manu priore:□+6 iniuria impetus□-3 velocitas inuriae",
  "item.minecraft.netherite_sword": "gladius infernitae□□in manu priore:□+7 iniuria impetus□-2.4 velocitas inuriae",
  "item.minecraft.netherite_shovel": "pala infernitae□□in manu priore:□+5.5 iniuria impetus□-3 velocitas inuriae",
  "item.minecraft.netherite_pickaxe": "dolabra infernitae□□in manu priore:□+5 iniuria impetus□-2.8 velocitas inuriae",
  "item.minecraft.netherite_axe": "securis infernitae□□in manu priore:□+9 iniuria impetus□-3 velocitas inuriae",
  "item.minecraft.string": "filum",
  "item.minecraft.feather": "penna",
  "item.minecraft.gunpowder": "pulvis pyrius",
  "item.minecraft.wooden_hoe": "sarculum ligneum□□in manu priore:□-3 velocitas inuriae",
  "item.minecraft.stone_hoe": "sarculum saxeum□□in manu priore:□-2 velocitas inuriae",
  "item.minecraft.iron_hoe": "sarculum ferreum□□in manu priore:□-1 velocitas inuriae",
  "item.minecraft.diamond_hoe": "sarculum adamantinum□□in manu priore:",
  "item.minecraft.golden_hoe": "sarculum aureum□□in manu priore:□-3 velocitas inuriae",
  "item.minecraft.netherite_hoe": "sarculum infernitae□□in manu priore:",
  "item.minecraft.wheat_seeds": "semina frumenti",
  "item.minecraft.wheat": "frumentum",
  "item.minecraft.bread": "panis",
  "item.minecraft.leather_helmet": "pileus scorteus□□in capite:□+1 armatura",
  "item.minecraft.leather_chestplate": "tunica scortea□□in corpore:□+3 armatura",
  "item.minecraft.leather_leggings": "bracae scorteae□□in cruribus:□+2 armatura",
  "item.minecraft.leather_boots": "calcei scortei□□in peditibus:□+1 armatura",
  "item.minecraft.chainmail_helmet": "galea reticuli ferrei□□in capite:□+2 armatura",
  "item.minecraft.chainmail_chestplate": "lorica reticuli ferrei□□in corpore:□+5 armatura",
  "item.minecraft.chainmail_leggings": "ocreae reticuli ferrei□□in cruribus:□+4 armatura",
  "item.minecraft.chainmail_boots": "caligae reticuli ferrei□□in peditibus:□+1 armatura",
  "item.minecraft.iron_helmet": "galea ferrea□□in capite:□+2 armatura",
  "item.minecraft.iron_chestplate": "lorica ferrea□□in corpore:□+6 armatura",
  "item.minecraft.iron_leggings": "ocreae ferreae□□in cruribus:□+5 armatura",
  "item.minecraft.iron_boots": "caligae ferreae□□in peditibus:□+2 armatura",
  "item.minecraft.diamond_helmet": "galea adamantina□□in capite:□+3 armatura□+2 fortitudo tegiminis",
  "item.minecraft.diamond_chestplate": "lorica adamantina□□in corpore:□+8 armatura□+2 fortitudo tegiminis",
  "item.minecraft.diamond_leggings": "ocreae adamantinae□□in cruribus:□+6 armatura□+2 fortitudo tegiminis",
  "item.minecraft.diamond_boots": "caligae adamantinae□□in peditibus:□+3 armatura□+2 fortitudo tegiminis",
  "item.minecraft.golden_helmet": "galea aurea□□in capite:□+2 armatura",
  "item.minecraft.golden_chestplate": "lorica aurea□□in corpore:□+5 armatura",
  "item.minecraft.golden_leggings": "ocreae aureae□□in cruribus:□+3 armatura",
  "item.minecraft.golden_boots": "caligae aureae□□in peditibus:□+1 armatura",
  "item.minecraft.netherite_helmet": "galea infernitae□□in capite:□+3 armatura□+3 fortitudo tegiminis□+1 repugnantia repellendi",
  "item.minecraft.netherite_chestplate": "lorica infernitae□□in corpore:□+8 armatura□+3 fortitudo tegiminis□+1 repugnantia repellendi",
  "item.minecraft.netherite_leggings": "ocreae infernitae□□in cruribus:□+6 armatura□+3 fortitudo tegiminis□+1 repugnantia repellendi",
  "item.minecraft.netherite_boots": "caligae infernitae□□in peditibus:□+3 armatura□+3 fortitudo tegiminis□+1 repugnantia repellendi",
  "item.minecraft.flint": "silex",
  "item.minecraft.porkchop": "suilla cruda",
  "item.minecraft.cooked_porkchop": "suilla cocta",
  "item.minecraft.painting": "pictura",
  "item.minecraft.golden_apple": "malum aureum",
  "item.minecraft.enchanted_golden_apple": "malum aureum incantatum",
  "block.minecraft.oak_sign": "titulus querceus",
  "block.minecraft.spruce_sign": "titulus piceae",
  "block.minecraft.birch_sign": "titulus betullae",
  "block.minecraft.jungle_sign": "titulus theobromatis",
  "block.minecraft.acacia_sign": "titulus acaciae",
  "block.minecraft.dark_oak_sign": "titulus quercus nigrae",
  "block.minecraft.crimson_sign": "titulus coccinus",
  "block.minecraft.warped_sign": "titulus distortus",
  "item.minecraft.bucket": "hama",
  "item.minecraft.water_bucket": "hama aquae",
  "item.minecraft.lava_bucket": "hama lavae",
  "item.minecraft.minecart": "plaustrum fodinae",
  "item.minecraft.saddle": "sagma",
  "item.minecraft.redstone": "pulvis rubrolapideus",
  "item.minecraft.snowball": "pila nivis",
  "item.minecraft.oak_boat": "ratis quercea",
  "item.minecraft.leather": "corium",
  "item.minecraft.milk_bucket": "hama lactis",
  "item.minecraft.pufferfish_bucket": "hama cum pisce aculeato",
  "item.minecraft.salmon_bucket": "hama cum salmone",
  "item.minecraft.cod_bucket": "hama cum morua",
  "item.minecraft.tropical_fish_bucket": "hama cum pisce multigeneri",
  "item.minecraft.brick": "later",
  "item.minecraft.clay_ball": "pila argillae",
  "block.minecraft.dried_kelp_block": "cubus algarum siccarum",
  "item.minecraft.paper": "papyrus",
  "item.minecraft.book": "liber",
  "item.minecraft.slime_ball": "pila muci",
  "item.minecraft.chest_minecart": "plaustrum fodinae cum cista",
  "item.minecraft.furnace_minecart": "plaustrum fodinae cum fornace",
  "item.minecraft.egg": "ovum",
  "item.minecraft.compass": "acus magnetica",
  "item.minecraft.fishing_rod": "harundo",
  "item.minecraft.clock": "horologium",
  "item.minecraft.glowstone_dust": "pulvis lucilapideus",
  "item.minecraft.cod": "morua cruda",
  "item.minecraft.salmon": "salmo crudus",
  "item.minecraft.tropical_fish": "piscis multigener",
  "item.minecraft.pufferfish": "piscis aculeatus",
  "item.minecraft.cooked_cod": "morua cocta",
  "item.minecraft.cooked_salmon": "salmo coctus",
  "item.minecraft.ink_sac": "saccus atramenti",
  "item.minecraft.red_dye": "tinctura rubra",
  "item.minecraft.green_dye": "tinctura viridis",
  "item.minecraft.cocoa_beans": "fabae theobromatis",
  "item.minecraft.lapis_lazuli": "lapis lazuli",
  "item.minecraft.purple_dye": "tinctura purpurea",
  "item.minecraft.cyan_dye": "tinctura cyanea",
  "item.minecraft.light_gray_dye": "tinctura cana",
  "item.minecraft.gray_dye": "tinctura cinerea",
  "item.minecraft.pink_dye": "tinctura rosea",
  "item.minecraft.lime_dye": "tinctura prasina",
  "item.minecraft.yellow_dye": "tinctura flava",
  "item.minecraft.light_blue_dye": "tinctura aeria",
  "item.minecraft.magenta_dye": "tinctura rubropurpurea",
  "item.minecraft.orange_dye": "tinctura aurantia",
  "item.minecraft.bone_meal": "ossa molita",
  "item.minecraft.blue_dye": "tinctura caerulea",
  "item.minecraft.brown_dye": "tinctura brunnea",
  "item.minecraft.black_dye": "tinctura nigra",
  "item.minecraft.white_dye": "tinctura alba",
  "item.minecraft.bone": "os",
  "item.minecraft.sugar": "saccharum",
  "block.minecraft.cake": "placenta",
  "block.minecraft.white_bed": "lectus albus",
  "block.minecraft.orange_bed": "lectus aurantius",
  "block.minecraft.magenta_bed": "lectus rubropurpureus",
  "block.minecraft.light_blue_bed": "lectus aerius",
  "block.minecraft.yellow_bed": "lectus flavus",
  "block.minecraft.lime_bed": "lectus prasinus",
  "block.minecraft.pink_bed": "lectus roseus",
  "block.minecraft.gray_bed": "lectus cinereus",
  "block.minecraft.light_gray_bed": "lectus canus",
  "block.minecraft.cyan_bed": "lectus cyaneus",
  "block.minecraft.purple_bed": "lectus purpureus",
  "block.minecraft.blue_bed": "lectus caeruleus",
  "block.minecraft.brown_bed": "lectus brunneus",
  "block.minecraft.green_bed": "lectus viridis",
  "block.minecraft.red_bed": "lectus ruber",
  "block.minecraft.black_bed": "lectus niger",
  "item.minecraft.cookie": "crustulum",
  "item.minecraft.filled_map": "charta□#0",
  "item.minecraft.shears": "forfex",
  "item.minecraft.melon_slice": "sectio peponis",
  "item.minecraft.dried_kelp": "alga sicca",
  "item.minecraft.pumpkin_seeds": "semina cucurbitae",
  "item.minecraft.melon_seeds": "semina peponis",
  "item.minecraft.beef": "bubula cruda",
  "item.minecraft.cooked_beef": "bubula cocta",
  "item.minecraft.chicken": "caro gallinacea cruda",
  "item.minecraft.cooked_chicken": "caro gallinacea cocta",
  "item.minecraft.rotten_flesh": "caro putris",
  "item.minecraft.ender_pearl": "margarita finalis",
  "item.minecraft.blaze_rod": "virga flammifera",
  "item.minecraft.ghast_tear": "lacrima larvae",
  "item.minecraft.gold_nugget": "massa aurea",
  "item.minecraft.nether_wart": "verruca inferna",
  "item.minecraft.potion": "potio infabricabilis□effectus non est",
  "item.minecraft.glass_bottle": "uter vitreus",
  "item.minecraft.spider_eye": "oculus araneae",
  "item.minecraft.fermented_spider_eye": "oculus araneae fermentatus",
  "item.minecraft.blaze_powder": "pulvis flammifer",
  "item.minecraft.magma_cream": "massa magmatis",
  "block.minecraft.brewing_stand": "mixtarius",
  "block.minecraft.cauldron": "cortina",
  "item.minecraft.ender_eye": "oculus finalis",
  "item.minecraft.glistering_melon_slice": "sectio peponis fulgens",
  "item.minecraft.bat_spawn_egg": "ovum creationis vespertilionis",
  "item.minecraft.bee_spawn_egg": "ovum creationis apis",
  "item.minecraft.blaze_spawn_egg": "ovum creationis flammiferi",
  "item.minecraft.cat_spawn_egg": "ovum creationis feles",
  "item.minecraft.cave_spider_spawn_egg": "ovum creationis araneae cavernae",
  "item.minecraft.chicken_spawn_egg": "ovum creationis pulli",
  "item.minecraft.cod_spawn_egg": "ovum creationis moruae",
  "item.minecraft.cow_spawn_egg": "ovum creationis vaccae",
  "item.minecraft.creeper_spawn_egg": "ovum creationis serpetoris",
  "item.minecraft.dolphin_spawn_egg": "ovum creationis delphini",
  "item.minecraft.donkey_spawn_egg": "ovum creationis asini",
  "item.minecraft.drowned_spawn_egg": "ovum creationis mersi",
  "item.minecraft.elder_guardian_spawn_egg": "ovum creationis custodis postnati",
  "item.minecraft.enderman_spawn_egg": "ovum creationis hominis finalis",
  "item.minecraft.endermite_spawn_egg": "ovum creationis acari finalis",
  "item.minecraft.evoker_spawn_egg": "ovum creationis evocatoris",
  "item.minecraft.fox_spawn_egg": "ovum creationis vulpis",
  "item.minecraft.ghast_spawn_egg": "ovum creationis larvae",
  "item.minecraft.guardian_spawn_egg": "ovum creationis custodis",
  "item.minecraft.hoglin_spawn_egg": "ovum creationis ferusporci",
  "item.minecraft.horse_spawn_egg": "ovum creationis equi",
  "item.minecraft.husk_spawn_egg": "ovum creationis cassi",
  "item.minecraft.llama_spawn_egg": "ovum creationis lamae",
  "item.minecraft.magma_cube_spawn_egg": "ovum creationis cubi magmatis",
  "item.minecraft.mooshroom_spawn_egg": "ovum creationis vaccae fungalis",
  "item.minecraft.mule_spawn_egg": "ovum creationis muli",
  "item.minecraft.ocelot_spawn_egg": "ovum creationis pardi",
  "item.minecraft.panda_spawn_egg": "ovum creationis pandae",
  "item.minecraft.parrot_spawn_egg": "ovum creationis psittaci",
  "item.minecraft.phantom_spawn_egg": "ovum creationis phantasmatis",
  "item.minecraft.pig_spawn_egg": "ovum creationis porci",
  "item.minecraft.piglin_spawn_egg": "ovum creationis homoporci",
  "item.minecraft.pillager_spawn_egg": "ovum creationis praedatoris",
  "item.minecraft.polar_bear_spawn_egg": "ovum creationis ursi polaris",
  "item.minecraft.pufferfish_spawn_egg": "ovum creationis piscis aculeati",
  "item.minecraft.rabbit_spawn_egg": "ovum creationis cuniculi",
  "item.minecraft.ravager_spawn_egg": "ovum creationis vastatoris",
  "item.minecraft.salmon_spawn_egg": "ovum creationis salmonis",
  "item.minecraft.sheep_spawn_egg": "ovum creationis ovis",
  "item.minecraft.shulker_spawn_egg": "ovum creationis concheri",
  "item.minecraft.silverfish_spawn_egg": "ovum creationis lepismae",
  "item.minecraft.skeleton_spawn_egg": "ovum creationis sceleti",
  "item.minecraft.skeleton_horse_spawn_egg": "ovum creationis equi sceletalis",
  "item.minecraft.slime_spawn_egg": "ovum creationis muci",
  "item.minecraft.spider_spawn_egg": "ovum creationis araneae",
  "item.minecraft.squid_spawn_egg": "ovum creationis lolliginis",
  "item.minecraft.stray_spawn_egg": "ovum creationis aberratoris",
  "item.minecraft.strider_spawn_egg": "ovum creationis ambulatoris",
  "item.minecraft.trader_llama_spawn_egg": "ovum creationis lamae mercatoris",
  "item.minecraft.tropical_fish_spawn_egg": "ovum creationis piscis multigeneris",
  "item.minecraft.turtle_spawn_egg": "ovum creationis testudinis",
  "item.minecraft.vex_spawn_egg": "ovum creationis vexis",
  "item.minecraft.villager_spawn_egg": "ovum creationis vicani",
  "item.minecraft.vindicator_spawn_egg": "ovum creationis vindicatoris",
  "item.minecraft.wandering_trader_spawn_egg": "ovum creationis mercatoris vagi",
  "item.minecraft.witch_spawn_egg": "ovum creationis veneficae",
  "item.minecraft.wither_skeleton_spawn_egg": "ovum creationis sceletis deurentis",
  "item.minecraft.wolf_spawn_egg": "ovum creationis lupi",
  "item.minecraft.zoglin_spawn_egg": "ovum creationis ferusporci resurrecti",
  "item.minecraft.zombie_spawn_egg": "ovum creationis resurrecti",
  "item.minecraft.zombie_horse_spawn_egg": "ovum creationis equi resurrecti",
  "item.minecraft.zombie_villager_spawn_egg": "ovum creationis vicani resurrecti",
  "item.minecraft.zombified_piglin_spawn_egg": "ovum creationis homoporci resurrecti",
  "item.minecraft.experience_bottle": "uter incantandi",
  "item.minecraft.fire_charge": "missile igneum",
  "item.minecraft.writable_book": "liber et penna",
  "item.minecraft.written_book": "liber inscriptus",
  "item.minecraft.emerald": "smaragdus",
  "item.minecraft.item_frame": "forma rerum",
  "block.minecraft.flower_pot": "vas",
  "item.minecraft.carrot": "carota",
  "item.minecraft.potato": "patata",
  "item.minecraft.baked_potato": "patata cocta",
  "item.minecraft.poisonous_potato": "patata venenata",
  "item.minecraft.map": "charta inanis",
  "item.minecraft.golden_carrot": "carota aurea",
  "block.minecraft.skeleton_skull": "calva sceleti",
  "block.minecraft.wither_skeleton_skull": "calva sceleti deurentis",
  "block.minecraft.player_head": "caput lusoris",
  "block.minecraft.zombie_head": "caput resurrecti",
  "block.minecraft.creeper_head": "caput serpetoris",
  "block.minecraft.dragon_head": "caput draconis",
  "item.minecraft.carrot_on_a_stick": "carota in virga",
  "item.minecraft.warped_fungus_on_a_stick": "fungus distortus in virga",
  "item.minecraft.nether_star": "stella inferna",
  "item.minecraft.pumpkin_pie": "placenta de cucurbita",
  "item.minecraft.firework_rocket": "missile pyrotechnicum",
  "item.minecraft.firework_star": "nucleus pyrotechnicus",
  "item.minecraft.enchanted_book": "liber incantatus",
  "item.minecraft.nether_brick": "later infernus",
  "item.minecraft.quartz": "crystallum infernum",
  "item.minecraft.tnt_minecart": "plaustrum fodinae cum dynamite",
  "item.minecraft.hopper_minecart": "plaustrum fodinae cum infundibulo",
  "item.minecraft.prismarine_shard": "fragmentum prismarinum",
  "item.minecraft.prismarine_crystals": "crystalla prismarinae",
  "item.minecraft.rabbit": "caro cuniculi cruda",
  "item.minecraft.cooked_rabbit": "caro cuniculi cocta",
  "item.minecraft.rabbit_stew": "ius de cuniculo",
  "item.minecraft.rabbit_foot": "pes cuniculi",
  "item.minecraft.rabbit_hide": "pellis cunicularis",
  "item.minecraft.armor_stand": "statumen armorum",
  "item.minecraft.iron_horse_armor": "tegimen equinum ferreum",
  "item.minecraft.golden_horse_armor": "tegimen equinum aureum",
  "item.minecraft.diamond_horse_armor": "tegimen equinum adamantinum",
  "item.minecraft.leather_horse_armor": "tegimen equinum scorteum",
  "item.minecraft.lead": "copula",
  "item.minecraft.name_tag": "nota nominis",
  "item.minecraft.command_block_minecart": "plaustrum fodinae cum cubo iussorum",
  "item.minecraft.mutton": "agnina cruda",
  "item.minecraft.cooked_mutton": "agnina cocta",
  "block.minecraft.white_banner": "vexillum album",
  "block.minecraft.orange_banner": "vexillum aurantium",
  "block.minecraft.magenta_banner": "vexillum rubropurpureum",
  "block.minecraft.light_blue_banner": "vexillum aerium",
  "block.minecraft.yellow_banner": "vexillum flauum",
  "block.minecraft.lime_banner": "vexillum prasinum",
  "block.minecraft.pink_banner": "vexillum roseum",
  "block.minecraft.gray_banner": "vexillum cinereum",
  "block.minecraft.light_gray_banner": "vexillum canum",
  "block.minecraft.cyan_banner": "vexillum cyaneum",
  "block.minecraft.purple_banner": "vexillum purpureum",
  "block.minecraft.blue_banner": "vexillum venetum",
  "block.minecraft.brown_banner": "vexillum brunneum",
  "block.minecraft.green_banner": "vexillum viride",
  "block.minecraft.red_banner": "vexillum rubrum",
  "block.minecraft.black_banner": "vexillum nigrum",
  "item.minecraft.end_crystal": "crystallum finalis",
  "item.minecraft.chorus_fruit": "pomus chori",
  "item.minecraft.popped_chorus_fruit": "pomus chori displosus",
  "item.minecraft.beetroot": "beta",
  "item.minecraft.beetroot_seeds": "semina betaceae",
  "item.minecraft.beetroot_soup": "ius betaceum",
  "item.minecraft.dragon_breath": "halitus draconis",
  "item.minecraft.splash_potion": "potio infabricabilis aspergens□effectus non est",
  "item.minecraft.spectral_arrow": "sagitta spectri",
  "item.minecraft.tipped_arrow": "sagitta imbuta infabricabilis□effectus non est",
  "item.minecraft.lingering_potion": "potio infabricabilis commorans□effectus non est",
  "item.minecraft.shield": "scutum",
  "item.minecraft.elytra": "elytra",
  "item.minecraft.spruce_boat": "ratis piceae",
  "item.minecraft.birch_boat": "ratis betullae",
  "item.minecraft.jungle_boat": "ratis theobromatis",
  "item.minecraft.acacia_boat": "ratis acaciae",
  "item.minecraft.dark_oak_boat": "ratis quercus nigrae",
  "item.minecraft.totem_of_undying": "figura immortalitatis",
  "item.minecraft.shulker_shell": "concha concheri",
  "item.minecraft.iron_nugget": "massa ferrea",
  "item.minecraft.knowledge_book": "liber scientiae",
  "item.minecraft.debug_stick": "virga emendandi",
  "item.minecraft.music_disc_13": "phonodiscus□c-cdxviii - xiii",
  "item.minecraft.music_disc_cat": "phonodiscus□c-cdxviii - cattus",
  "item.minecraft.music_disc_blocks": "phonodiscus□c-cdxviii - cubi",
  "item.minecraft.music_disc_chirp": "phonodiscus□c-cdxviii - cantus",
  "item.minecraft.music_disc_far": "phonodiscus□c-cdxviii - longe",
  "item.minecraft.music_disc_mall": "phonodiscus□c-cdxviii - forum",
  "item.minecraft.music_disc_mellohi": "phonodiscus□c-cdxviii - mellohia",
  "item.minecraft.music_disc_stal": "phonodiscus□c-cdxviii - clepsit",
  "item.minecraft.music_disc_strad": "phonodiscus□c-cdxviii - stradiuarius",
  "item.minecraft.music_disc_ward": "phonodiscus□c-cdxviii - praeses",
  "item.minecraft.music_disc_11": "phonodiscus□c-cdxviii - xi",
  "item.minecraft.music_disc_wait": "phonodiscus□c-cdxviii - mane",
  "item.minecraft.music_disc_pigstep": "phonodiscus□lena raina - gradus porci",
  "item.minecraft.trident": "tridens□□in manu priore:□+8 iniuria impetus□-2.9 velocitas inuriae",
  "item.minecraft.phantom_membrane": "membrana phantasmatis",
  "item.minecraft.nautilus_shell": "concha nautili",
  "item.minecraft.heart_of_the_sea": "cor maris",
  "item.minecraft.crossbow": "manuballista",
  "item.minecraft.suspicious_stew": "ius suspectum",
  "block.minecraft.loom": "tela",
  "item.minecraft.flower_banner_pattern": "exemplar vexilli□imago floris",
  "item.minecraft.creeper_banner_pattern": "exemplar vexilli□imago serpetoris",
  "item.minecraft.skull_banner_pattern": "exemplar vexilli□imago calvae",
  "item.minecraft.mojang_banner_pattern": "exemplar vexilli□res",
  "item.minecraft.globe_banner_pattern": "exemplar vexilli□globus",
  "item.minecraft.piglin_banner_pattern": "exemplar vexilli□rostrum",
  "block.minecraft.composter": "cupa laetaminis",
  "block.minecraft.barrel": "cupa",
  "block.minecraft.smoker": "fumigator",
  "block.minecraft.blast_furnace": "caminus",
  "block.minecraft.cartography_table": "mensa chartographiae",
  "block.minecraft.fletching_table": "mensa sagittationis",
  "block.minecraft.grindstone": "cos",
  "block.minecraft.lectern": "lectrum",
  "block.minecraft.smithing_table": "mensa fabricae",
  "block.minecraft.stonecutter": "saxumsecator",
  "block.minecraft.bell": "campana",
  "block.minecraft.lantern": "lanterna",
  "block.minecraft.soul_lantern": "lanterna animarum",
  "item.minecraft.sweet_berries": "bacae dulces",
  "block.minecraft.campfire": "focus",
  "block.minecraft.soul_campfire": "focus animarum",
  "block.minecraft.shroomlight": "lucifungus",
  "item.minecraft.honeycomb": "favus",
  "block.minecraft.bee_nest": "nidus apium",
  "block.minecraft.beehive": "alvearium",
  "item.minecraft.honey_bottle": "uter mellis",
  "block.minecraft.honey_block": "cubus mellis",
  "block.minecraft.honeycomb_block": "cubus favorum",
  "block.minecraft.lodestone": "magnes lapis",
  "block.minecraft.netherite_block": "cubus infernitae",
  "block.minecraft.ancient_debris": "antiqua sedimina",
  "block.minecraft.target": "palus",
  "block.minecraft.crying_obsidian": "lapis obsidianus flens",
  "block.minecraft.blackstone": "saxum nigrum",
  "block.minecraft.blackstone_slab": "gradus saxi nigri",
  "block.minecraft.blackstone_stairs": "scalae saxi nigri",
  "block.minecraft.gilded_blackstone": "saxum nigrum aurifer",
  "block.minecraft.polished_blackstone": "saxum nigrum politum",
  "block.minecraft.polished_blackstone_slab": "gradus saxi nigri politi",
  "block.minecraft.polished_blackstone_stairs": "scalae saxi nigri politi",
  "block.minecraft.chiseled_polished_blackstone": "saxum nigrum politum caelatum",
  "block.minecraft.polished_blackstone_bricks": "lateres saxi nigri politi",
  "block.minecraft.polished_blackstone_brick_slab": "gradus laterum saxi nigri politi",
  "block.minecraft.polished_blackstone_brick_stairs": "scalae laterum saxi nigri politi",
  "block.minecraft.cracked_polished_blackstone_bricks": "lateres saxi nigri politi rimosi",
  "block.minecraft.respawn_anchor": "ancora reincunabuli",
}
export const la_la = items; 
